import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledTextBlock = styled.div`
  max-width: 35.625rem;

  @media screen and (max-width: 64rem) {
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  @media screen and (max-width: 35.625rem) {
    width: 100%;
  }

  p {
    font-size: 1.0625rem;
    font-family: 'Source Serif Pro';
    font-weight: 400;
    line-height: 30px;
    margin: 2em 0;
  }

  h2 {
    font-size: 1.9rem;
    margin: 1rem 0;

    + p {
      margin-top: -0.5rem;
    }

    @media screen and (max-width: 40rem) {
      font-size: 1.7rem;
    }
  }

  h3 {
    font-size: 1.7rem;
    margin: 1rem 0;

    + p {
      margin-top: -0.5rem;
    }

    @media screen and (max-width: 40rem) {
      font-size: 1.4rem;
    }
  }

  h4 {
    font-size: 1.4rem;
    margin: 1rem 0;

    + p {
      margin-top: -0.5rem;
    }

    @media screen and (max-width: 40rem) {
      font-size: 1.1rem;
    }
  }

  a {
    color: ${props => props.theme.secondary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  blockquote,
  blockquote p {
    margin: 2rem 0;

    @media screen and (max-width: 64rem) {
      margin: 0;
    }
  }

  blockquote p {
    color: #8b8b8b;
    font-family: 'Source Sans Pro';
    font-style: italic;
    font-weight: 300;
    font-size: 1.75rem;
    line-height: 1.2857em;
  }

  ol {
    line-height: 30px;
    padding-left: 2.3rem;
    margin: 2em 0;
  }

  ul {
    line-height: 30px;
    padding-left: 2.3rem;
    margin: 2em 0;
  }
`;

const TextBlock = ({ content }) => {
  return <StyledTextBlock dangerouslySetInnerHTML={{ __html: content }} />;
};

TextBlock.propTypes = {
  content: PropTypes.string.isRequired
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/TextBlock.js